export default __webpack_public_path__ + "static/media/teardrop.cc640de1.mp3";